export const ASSET_GROUPS = ["Cylinder", "Meter", "Stove"];

export const ASSET_CONDITIONS = {
  Stove: ["New", "Refurbished"],
  Cylinder: ["Full", "Ready for Filling"],
  Meter: ["Healthy"],
};

const ADDITIONAL_DATA_TO_GENERATE = {
  Cylinder: {
    year: 2026,
    month: 1,
    cylinderWeight: 5,
  },
  Meter: {
    calibratedAt: new Date(Date.now() - 24 * 60 * 60 * 1000),
    manufactureName: "mock",
    manufactureLocation: "mock",
  },
  Stove: {},
};

export const getAdditionalData = (type, data) => {
  switch (type) {
    case "Cylinder":
      return {
        type: data.type,
        supplier: data.supplier,
        totalWeight: Number(data.totalWeight),
        condition: data.condition,
        ...ADDITIONAL_DATA_TO_GENERATE[type],
      };
    case "Meter":
      return {
        ...data,
        ...ADDITIONAL_DATA_TO_GENERATE[type],
      };
    case "Stove":
      return {
        type: data.type,
        supplier: data.supplier,
        model: data.model,
        GRN: data.GRN,
        condition: data.condition,
        ...(data.condition === "Refurbished" ? { refurbishSupplier: data.refurbishSupplier } : {}),
        ...ADDITIONAL_DATA_TO_GENERATE[type],
      };
    default:
      return {};
  }
};

export const _superUsers = [
  "Vadym.Pasieka@kopatechnology.com",
  "Anna.Alieksieienko@kopatechnology.com",
  // "Vladyslav.Yevtushenko@kopatechnology.com",
];

export const _adminToolsSuperUsers = [
  "anna.alieksieienko@kopatechnology.com",
  "yurii.tyvodar@mgas.ke",
  "brian.wamwenje@mgas.ke",
  "brian.muyundo@mgas.ke",
  "benjamin.tonui@mgas.ke",
  "raphael.lawi@kopatechnology.com",
  "felister.paul@mgas.ke",
  "alfred.ogol@mgas.ke",
];
